module.exports = __webpack_public_path__ + "static/media/Nile Buisness Tower Still 08.51f8daa0.webp";